module.exports = __webpack_public_path__ + "img/Cancel.0647a27e.svg";